"use client";

import { List } from "@dafiti/closet-ui";

import { useFilterList } from "../../../hooks/useFilterList.hook";
import { useFiltersStore } from "../../../stores/filters.store";
import type { DefaultBooleanFacet, Facet } from "../../../types/filters.type";
import { FilterListItemDrill, FilterListItemSwitch } from "./FilterListItem";

type FilterListProps = {
  onNavigate: (facet: Facet) => void;
};

export function FilterList({ onNavigate }: FilterListProps) {
  const draftFacets = useFiltersStore((state) => state.draftFacets);
  const { items } = useFilterList(draftFacets ?? []);

  if (!draftFacets || items.length === 0) return null;

  return (
    <List as="div" data-testid="filter-list">
      {items.map(({ facet, variant }) => {
        if (variant === "switch") {
          const booleanFacet = facet as DefaultBooleanFacet;
          return (
            <FilterListItemSwitch key={facet.field} facet={booleanFacet} />
          );
        }

        const disableDrill =
          facet.component === "CustomCategory" &&
          (!facet.tree?.children || facet.tree.children.length === 0);

        return (
          <FilterListItemDrill
            key={facet.field}
            facet={facet}
            onNavigate={onNavigate}
            disableDrill={disableDrill}
          />
        );
      })}
    </List>
  );
}
